import { withStyles } from '@material-ui/core';
import MapPreview from './MapComponents/MapPreview';
import MapHeader from './MapComponents/MapHeader';

const styles = (theme) => ({
  mapPreview: {
    flex: 1,
    position: 'relative',
    border: `1px solid ${theme.dividerColorSecondary}`
  },
  mapPreviewHidden: {
    display: 'none',
    height: 0,
    flex: 0
  },
  mapPreviewMaximized: {
    flex: 2,
    border: `1px solid ${theme.dividerColorSecondary}`
  }
});

const RenderMap = ({
  classes,
  mapId,
  selectedRoutes,
  unassignedPickups,
  driverKpiData,
  headerLabel,
  mapConfig,
  glEventHub,
  maximizedMap,
  toggleMaximize,
  shouldShowRoutePreview = true
}) => {

  const getMapPreviewClass = ({ classes, mapId, maximizedMap }) => {
    if (maximizedMap === mapId) return classes.mapPreviewMaximized;
    if (maximizedMap) return classes.mapPreviewHidden;
    return classes.mapPreview;
  };

  const mapClass = getMapPreviewClass({ classes, mapId, maximizedMap });
  return (
    <div className={mapClass}>
      <MapHeader
        mapId={mapId}
        headerLabel={headerLabel}
        driverKpiData={driverKpiData}
        isMaximized={maximizedMap === mapId}
        toggleMaximize={toggleMaximize}
        mapConfig={mapConfig}
        shouldShowRoutePreview={shouldShowRoutePreview}
      />
      <MapPreview
        mapId={mapId}
        glEventHub={glEventHub}
        selectedRoutes={selectedRoutes}
        unassignedPickups={unassignedPickups}
        mapConfig={mapConfig}
        shouldShowRoutePreview={shouldShowRoutePreview}
      />
    </div>
  );
};

export default withStyles(styles)(RenderMap);
